import { useState } from 'react';
import {
  InputLabel,
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Tooltip,
  Box,
} from '@mui/material';
import { jidsNRCForms } from '../../../../../data/forms/nrc/nrcDropdownOptions.js';
import axios from 'axios';

const GNIEUpdateRequestForm = ({
  translations,
  user,
  handleFormSelectionReset,
  setSnackbarMessage,
  setIsSnackbarOpen,
  setSnackbarSeverity,
}) => {
  const [form, setForm] = useState({
    jurisdiction: '',
    gnieArticleNumber: '',
    description: '',
    email: user.email,
    emailAddress: user.email,
    displayName: user.displayName,
    userId: user.userId,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleClear = () => {
    setForm({
      ...form,
      jurisdiction: '',
      gnieArticleNumber: '',
      description: '',
    });
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_ENDPOINT_FORMS}/uscc/gnieUpdate/submit`,
        data: {
          ...form,
        },
      });
      setSnackbarMessage('Form submitted successfully!');
      setSnackbarSeverity('success');
      setIsSnackbarOpen(true);
      setIsSubmitting(false);
      handleClear();
      handleFormSelectionReset();
    } catch (error) {
      console.error('Error submitting form:', error);
      setSnackbarMessage(
        'There was an error submitting the form. Please try again. If the problem persists, contact support.'
      );
      setSnackbarSeverity('error');
      setIsSnackbarOpen(true);
      setIsSubmitting(false);
    }
  };

  const isFormValid = () => {
    const { jurisdiction, gnieArticleNumber, description } = form;

    if (!jurisdiction || !gnieArticleNumber || !description) {
      return false;
    }

    return true;
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          display: 'flex',
          justifyItems: 'center',
          width: { xs: 'auto', md: 'var(--forms-layout-width, 90vw)' },
        }}
      >
        <Grid size={12}>
          <FormControl
            required
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>
              {translations.jurisdiction || 'Jurisdiction'}
            </InputLabel>
            <Select
              value={form.jurisdiction}
              label={translations.jurisdiction || 'Jurisdiction'}
              onChange={handleChange}
              name='jurisdiction'
            >
              {jidsNRCForms.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label='GNIE Article Number'
            name='gnieArticleNumber'
            required
            value={form.gnieArticleNumber}
            onChange={handleChange}
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          />
          <TextField
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
            value={form.description}
            onChange={handleChange}
            label='Description'
            name='description'
            multiline
            rows={4.1}
            required
          />
          <TextField
            label='Associate Name'
            disabled
            value={`${user.firstName} ${user.lastName}`}
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          />
        </Grid>
        <Grid
          size={12}
          sx={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            variant='contained'
            sx={{
              backgroundColor: 'var(--aldebaran-yellow)',
              color: '#000000',
              fontFamily: 'BrightstarSans-Regular',
              width: '10%',
            }}
            onClick={handleClear}
          >
            Clear
          </Button>
          <Tooltip
            title={
              !isFormValid()
                ? 'Please fill in all required fields to enable the Submit button'
                : ''
            }
            arrow
          >
            <Box>
              <Button
                disabled={!isFormValid() || isSubmitting}
                variant='contained'
                sx={{
                  backgroundColor: 'var(--vega-blue)',
                  fontFamily: 'BrightstarSans-Regular',
                  width: '100%',
                }}
                onClick={handleSubmit}
                loading={isSubmitting}
              >
                {'Submit'}
              </Button>
            </Box>
          </Tooltip>
        </Grid>
      </Grid>
    </>
  );
};

export default GNIEUpdateRequestForm;
